// extracted by mini-css-extract-plugin
module.exports = {"carouselLeftArrow":"CarouselLeftArrow-module__carouselLeftArrow___3emc7","studio":"CarouselLeftArrow-module__studio___2nP8T"};